import {type VFC} from 'react';
import {Helmet} from 'react-helmet';

export const Favicons: VFC<{
  brand: 'BOS' | 'LTB';
}> = ({brand}) => (
  <Helmet>
    <link
      href={new URL(
        `../assets/favicons/${brand}/favicon.ico?no-inline`,
        import.meta.url
      ).toString()}
      rel='shortcut icon'
    />
    {[16, 32, 48].map((size) => (
      <link
        href={new URL(
          `../assets/favicons/${brand}/favicon-${size}x${size}.png?no-inline`,
          import.meta.url
        ).toString()}
        key={size}
        rel='icon'
        type='image/png'
      />
    ))}
  </Helmet>
);
